// notifications.js - Simplified for Discord only
import api from './api';

export const getNotificationSubscriptions = async (params = {}) => {
  const response = await api.get('/notifications/subscriptions', { params });
  return response.data;
};

export const createNotificationSubscription = async (subscriptionData) => {
  // Always set platform to discord
  const transformedData = {
    platform: 'discord',  // Force Discord
    webhook_url: subscriptionData.webhook_url,
    event_types: subscriptionData.events || ['error', 'warning', 'info'],
    is_active: subscriptionData.is_active !== false
  };
  
  const response = await api.post('/notifications/subscriptions', transformedData);
  return response.data;
};

export const updateNotificationSubscription = async (id, subscriptionData) => {
  const transformedData = {
    platform: 'discord',  // Force Discord
    webhook_url: subscriptionData.webhook_url,
    event_types: subscriptionData.events || ['error', 'warning', 'info'],
    is_active: subscriptionData.is_active !== false
  };
  
  const response = await api.put(`/notifications/subscriptions/${id}`, transformedData);
  return response.data;
};

export const deleteNotificationSubscription = async (id) => {
  const response = await api.delete(`/notifications/subscriptions/${id}`);
  return response.data;
};

// Add the missing function that Header is trying to import
export const getUnreadNotifications = async () => {
  const response = await api.get('/notifications/unread-count');
  return response.data;
};

// Add the function that Header is actually calling
export const getUnreadCount = async () => {
  try {
    const response = await api.get('/notifications/unread');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch unread count:', error);
    return 0; // Return 0 on error
  }
};